module.exports = __webpack_public_path__ + "static/media/menu-blue.29f2051b.svg";